import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { PROD_BASE_URL } from "core/constants";
import BaseMeta from "./BaseMeta";
import SocialMeta from "./SocialMeta";
export var PageMeta = function (_a) {
    var title = _a.title, description = _a.description, useSocialMediaTags = _a.useSocialMediaTags, // (bool) include facebook & twitter meta tags
    previewImg = _a.previewImg, // (string) image to show on facebook & twitter share links
    previewImgSize = _a.previewImgSize, // (number, string, object) image size, example: 200 or "200" will be treated as 200x200 (square). Or customize dimensions via `{ width: 100, height: 200 }`
    previewImgAlt = _a.previewImgAlt, // (string) alt text of image file
    twitterTitle = _a.twitterTitle, // (string) custom twitter title; if absent, `title` is used
    twitterDescription = _a.twitterDescription, // (string) custom twitter description; if absent, `description` is used
    twitterCardContent = _a.twitterCardContent, // (string) "summary", "summary_large_image", etc.
    noindex = _a.noindex, // (bool) if `true`, bots will crawl urls on the page but exclude this page from search results
    indexContent = _a.indexContent, // (string) custom robots meta tag value
    structuredData = _a.structuredData, // (object) ld+json schema
    canonicalURL = _a.canonicalURL, // (string) ideal page url (google will then ignore alternative url variations, ish lol)
    prevPage = _a.prevPage, // (string) url to previous paginated results page (exclude if on page 1)
    nextPage = _a.nextPage, // (string) url to next paginated results page (exclude if on last page)
    children = _a.children;
    // Remove seo-related noscript content
    useEffect(function () {
        var noscriptContent = document.getElementById("content_summary");
        if (noscriptContent) {
            noscriptContent.remove();
        }
    }, []);
    var canonical = canonicalURL
        ? canonicalURL
        : typeof window === "undefined"
            ? ""
            : PROD_BASE_URL + window.location.pathname;
    var robotsContent = noindex ? "noindex" : indexContent || "index,follow";
    return (_jsxs(_Fragment, { children: [_jsx(BaseMeta, { robotsContent: robotsContent, canonical: canonical, title: title, description: description, structuredData: structuredData, prevPage: prevPage, nextPage: nextPage, children: children }), !!useSocialMediaTags && (_jsx(SocialMeta, { title: title, description: description, canonical: canonical, previewImg: previewImg, previewImgSize: previewImgSize, previewImgAlt: previewImgAlt, twitterTitle: twitterTitle, twitterDescription: twitterDescription, twitterCardContent: twitterCardContent }))] }));
};
export default PageMeta;
